export const API_KEY_CREATE_OR_EDIT_MODAL_KEY = 'createOrEditApiKey';
